export default __webpack_public_path__ + "static/media/back_arrow.d065c629.svg";